import { useMutation } from '@apollo/client'
import {
  So_RemoteCreateUserListDocument,
  So_RemoteGetUserListsDocument,
} from '@shared/gql/sostoslista-document-nodes'

import { shoppingListsQueryContext } from './shopping-lists-query-context'

export const useCreateUserListQuery = (storeId: string) => {
  const [createNewList] = useMutation(So_RemoteCreateUserListDocument, {
    ...shoppingListsQueryContext,
  })
  return (name: string) =>
    createNewList({
      variables: {
        storeId,
        name,
      },

      update: (cache, response) => {
        if (response.errors) {
          throw new Error('Could not create new list')
        }

        const cachedLists = cache.readQuery({
          query: So_RemoteGetUserListsDocument,
          variables: {
            storeId,
          },
        })

        cache.writeQuery({
          query: So_RemoteGetUserListsDocument,
          variables: {
            storeId,
          },
          data: {
            __typename: 'Query',
            shoppingLists: [
              {
                ...response.data?.createShoppingList,
              },
              ...(cachedLists?.shoppingLists || []),
            ],
          },
        })
      },
    })
}
